import React, { useState } from "react";
import { X, Mail, Shield } from "lucide-react";
import Button from "./Button";

const EmailVerificationModal = ({
  isOpen,
  onClose,
  onVerify,
  newEmail,
  isVerifying = false,
}) => {
  const [verificationCode, setVerificationCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (verificationCode.length === 6) {
      onVerify(verificationCode);
    }
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setVerificationCode(value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-gray-900/95 backdrop-blur-xl border border-white/20 rounded-2xl p-6 w-full max-w-md mx-4 shadow-2xl">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#B8460E]/20 rounded-full">
              <Mail className="h-5 w-5 text-[#B8460E]" />
            </div>
            <h3 className="text-xl font-semibold text-white">
              Verify Email Change
            </h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-gray-400" />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-gray-300 mb-4">
            We've sent a 6-digit verification code to:
          </p>
          <div className="p-3 bg-white/5 rounded-lg border border-white/10">
            <p className="text-white font-medium">{newEmail}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-white mb-2">
              Verification Code
            </label>
            <input
              type="text"
              value={verificationCode}
              onChange={handleCodeChange}
              className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white text-center text-2xl font-mono tracking-widest placeholder-white/50 focus:ring-2 focus:ring-[#B8460E]/50 focus:border-[#B8460E]/50 transition-all duration-300"
              placeholder="000000"
              maxLength={6}
            />
            <p className="text-xs text-gray-400 mt-1">
              Enter the 6-digit code from your email
            </p>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              onClick={onClose}
              variant="ghost"
              className="flex-1 bg-white/10 text-white hover:bg-white/20"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={verificationCode.length !== 6 || isVerifying}
              className="flex-1 bg-gradient-to-r from-[#B8460E] to-[#8B3A0E] hover:from-[#8B3A0E] hover:to-[#B8460E] text-white"
            >
              <Shield className="h-4 w-4 mr-2" />
              {isVerifying ? "Verifying..." : "Verify"}
            </Button>
          </div>
        </form>

        <div className="mt-4 text-center">
          <p className="text-xs text-gray-400">
            Didn't receive the code? Check your spam folder or try again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;
